module.exports = __webpack_public_path__ + "static/img/banner.6926b01c.jpg";